export default __webpack_public_path__ + "static/2374-036cf6f421addd66355fa5ac929829ee.gif";